<template>
    <b-modal
        id="match-maker-modal"
        v-model="modal"
        :ok-title="$t('common.close')"
        :title="`${$t('assignment.make_groups_for')} ${usersWithoutPartners.name}`"
        modal-class="apprentice-default-modal"
        ok-only
        size="xl">
        <div
            class="create-cooperation-groups"
            v-if="studentsCount">
            <div class="available-students">
                <div class="search-bar">
                    <b-input-group>
                        <b-form-input
                            v-model="search"
                            :placeholder="$t('common.search')">
                        </b-form-input>
                        <b-input-group-append>
                            <div class="icon">
                                <i class="fas fa-search fa-fw"></i>
                            </div>
                        </b-input-group-append>
                    </b-input-group>
                </div>

                <design-2021-student-tree-view-component
                    v-if="
                        (usersWithoutPartners.students && usersWithoutPartners.students.length) ||
                        (usersWithoutPartners.children && usersWithoutPartners.children.length)
                    "
                    :search-in="search"
                    :data="usersWithoutPartners"
                    @removeUser="removeUserFromSelectedUserIds($event)"
                    @selectUser="addUserToSelectedUserIds($event)">
                </design-2021-student-tree-view-component>

                <div
                    class="not-found with-header all-students-selected"
                    v-else>
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('assignment.all_students_added') }}</div>
                </div>

                <div class="ctas">
                    <b-button
                        class="btn-auto-group"
                        variant="outline-primary"
                        @click="autoGenerate">
                        <i class="fad fa-magic"></i>{{ $t('assignment.auto_groups') }}
                    </b-button>

                    <b-button
                        class="btn-add btn-new-group"
                        variant="primary"
                        @click="createGroup">
                        {{ $t('assignment.new_group') }}
                    </b-button>
                </div>
            </div>

            <div class="cooperation-groups-overview">
                <design-2021-apprentice-data-table
                    class="cooperation-groups-table"
                    :fields="fields"
                    :items="assignmentPartnerData"
                    :show-empty="true">
                    <template v-slot:cell(names)="data">
                        <div class="students">
                            <span
                                class="student"
                                v-for="apUser in data.item.assignment_partner_users"
                                :key="apUser.id">
                                {{ apUser.user.full_name }}
                                <b-button
                                    class="btn-remove"
                                    v-b-tooltip="'Verwijderen'"
                                    variant="danger-icon-only"
                                    @click="removeUserFromAssignmentPartner(apUser.id)">
                                </b-button>
                            </span>
                        </div>
                    </template>

                    <template v-slot:cell(actions)="data">
                        <div class="management-actions">
                            <b-button
                                class="btn-add"
                                v-if="selectedStudents.length"
                                :v-b-tooltip="$t('common.add')"
                                variant="primary-icon-only"
                                @click="addSelectedToAssignmentPartner(data.item.id)">
                            </b-button>
                            <b-button
                                class="btn-remove"
                                :v-b-tooltip="$t('assignment.delete_group')"
                                variant="danger-icon-only"
                                @click="removeAssignmentPartner(data.item.id)">
                            </b-button>
                        </div>
                    </template>

                    <template #empty>
                        <div class="not-found with-header user-list-empty">
                            <div class="icon">
                                <i class="fas fa-exclamation-circle"></i>
                            </div>
                            <div class="alert-notice">{{ $t('assignment.no_groups_created') }}</div>
                        </div>
                    </template>
                </design-2021-apprentice-data-table>
            </div>
        </div>
        <div
            class="not-found with-header all-students-selected"
            v-else>
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">
                {{ $t('assignment.no_students_available') }}
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    name: 'design-2021-assignment-edit-match-maker-modal-component',
    props: ['groupIdIn'],
    data() {
        return {
            assignmentCooperation: null,
            noSelectedStudents: false,
            assignmentPartners: [],
            usersWithoutPartners: [],
            studentsCount: 0,
            modal: false,
            selectedStudents: [],
            fields: [
                {
                    key: 'count',
                    label: this.$t('assignment.amount'),
                },
                {
                    key: 'names',
                    label: this.$t('common.students'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            search: '',
        };
    },
    computed: {
        assignmentPartnerData() {
            return this.assignmentPartners.map((ap) => {
                ap.count = ap.assignment_partner_users.length;
                return ap;
            });
        },
    },
    methods: {
        show(assignmentCooperation) {
            this.assignmentCooperation = assignmentCooperation;
            this.getFreshData();
            this.modal = true;
        },
        getFreshData() {
            this.axios
                .get(this.routes.getAssignmentPartnersForAssignmentCooperation(this.assignmentCooperation.id))
                .then(
                    (response) => {
                        this.studentsCount = response.data.student_count;
                        this.assignmentPartners = response.data.assignment_partners;
                        this.usersWithoutPartners = response.data.users_without_partners;
                        this.selectedStudents = [];
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
        },

        addUserToSelectedUserIds(student) {
            this.noSelectedStudents = false;
            this.selectedStudents.push(student);
        },

        removeUserFromSelectedUserIds(student0) {
            this.selectedStudents = this.selectedStudents.filter((student1) => student1.id !== student0.id);
        },

        addSelectedToAssignmentPartner(assignmentPartnerId) {
            if (!this.selectedStudents.length) {
                this.noSelectedStudents = true;
                return;
            }

            let data = {
                user_ids: this.selectedStudents.map((user) => user.id),
                assignment_partner_id: assignmentPartnerId,
            };
            this.axios.post(this.routes.addUsersToAssignmentPartner(), data).then(
                (response) => {
                    this.assignmentPartners = response.data.assignment_partners;
                    this.usersWithoutPartners = response.data.users_without_partners;
                    this.selectedStudents = [];
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        removeUserFromAssignmentPartner(apUserId) {
            this.alert
                .confirm(
                    this.$t('common.delete'),
                    this.$t('assignment.confirm_delete_student_from_group'),
                    this.$t('common.delete'),
                )
                .then((confirm) => {
                    this.axios.delete(this.routes.assignmentPartnerUserRemove(apUserId)).then(
                        (response) => {
                            this.assignmentPartners = response.data.assignment_partners;
                            this.usersWithoutPartners = response.data.users_without_partners;
                            this.selectedStudents = [];
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        createGroup() {
            let data = {
                assignment_cooperation_id: this.assignmentCooperation.id,
                group_id: this.groupIdIn,
                selected_student_ids: this.selectedStudents.map((user) => user.id),
            };

            this.axios.post(this.routes.assignmentPartnerManagerCreate(), data).then(
                (response) => {
                    this.assignmentPartners = response.data.assignment_partners;
                    this.usersWithoutPartners = response.data.users_without_partners;
                    this.selectedStudents = [];
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        removeAssignmentPartner(id) {
            this.alert
                .confirm(
                    this.$t('common.delete'),
                    this.$t('assignment.confirm_delete_cooperation'),
                    this.$t('common.delete'),
                )
                .then((confirm) => {
                    this.axios.delete(this.routes.assignmentPartnerDelete(id)).then(
                        (response) => {
                            this.assignmentPartners = response.data.assignment_partners;
                            this.usersWithoutPartners = response.data.users_without_partners;
                            this.selectedStudents = [];
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        autoGenerate() {
            this.axios.post(this.routes.assignmentPartnerAutoGenerate(this.assignmentCooperation.id)).then(
                (response) => {
                    this.assignmentPartners = response.data.assignment_partners;
                    this.usersWithoutPartners = response.data.users_without_partners;
                    this.selectedStudents = [];
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>
<style lang="scss" scoped>
.create-cooperation-groups {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    row-gap: $grid-gutter-width;
    position: relative;
    overflow-x: auto;
}

.search-bar {
    margin-bottom: $grid-gutter-width;

    .input-group {
        margin-left: 3px;
        margin-top: 3px;

        &:focus-within {
            box-shadow: 0 0 0 0.2rem rgba($primary, 25%);
            border-radius: $border-radius-content;
        }

        input {
            &:focus {
                box-shadow: none;
            }
        }
    }

    .input-group-append {
        color: $primary;
        align-items: center;
        background-color: $secondary-background-color;
        padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'ten');
        border-top-right-radius: $border-radius-content;
        border-bottom-right-radius: $border-radius-content;
    }
}

.available-students {
    flex: 0 0 25%;
    margin-bottom: $grid-gutter-width;

    .ctas {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        column-gap: map-get($grid-gutter-spacing, 'fifteen');
        margin-top: $grid-gutter-width;

        .btn {
            font-size: $default-font-size;
            line-height: 1;
            width: 100%;
        }

        .btn-auto-group {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

            i {
                margin-right: map-get($grid-gutter-spacing, 'eight');
            }
        }
    }
}

.cooperation-groups-overview {
    flex: 0 0 calc(75% - 30px);
}

.cooperation-groups-table {
    .students {
        display: flex;
        align-items: center;
        gap: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'eight');
    }

    .student {
        display: inline-flex;
        align-items: center;
        column-gap: map-get($grid-gutter-spacing, 'eight');
        font-size: 0.75rem;
        padding: map-get($grid-gutter-spacing, 'five');
        border: 1px solid $primary;
        border-radius: 12px;

        .btn-remove {
            font-size: 0.75rem;
        }

        &:hover {
            cursor: pointer;
            border-color: $danger;
        }
    }

    ::v-deep .search {
        .input-group {
            margin-top: 3px;
        }
    }
}

.group-pair-status {
    .icon {
        color: $primary;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .search {
        flex-grow: 1;
        max-width: 380px;

        .input-group {
            flex-wrap: nowrap;

            input {
                width: auto;
            }
        }
    }
}

@media (max-width: map-get($grid-breakpoints, 'sm')) {
    ::v-deep .cooperation-groups-table.cooperation-groups-table {
        table {
            > tbody {
                > tr {
                    > td[aria-colindex='2'] {
                        > div {
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .create-cooperation-groups {
        flex-direction: row;
    }

    .cooperation-groups-overview {
        flex: 0 0 calc(75% - 30px);

        &:before {
            position: absolute;
            content: '';
            display: block;
            width: 2px;
            height: 100%;
            background-color: darken($border-color, 10%);
            left: calc(25% + 15px);
        }
    }
}
</style>
